import styled from 'styled-components';

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1;
  background-color: ${(props) => props.theme.colors.accent};
  color: ${(props) => props.theme.colors.mainColor};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export default Tag;
